// removed by extract-text-webpack-plugin
module.exports = {"container":"page__container___2_P56","fadein":"page__fadein___2zsyL","home":"page__home___jn0nB","title":"page__title___3iSTG"};


//////////////////
// WEBPACK FOOTER
// ./src/containers/page/page.scss
// module id = 401
// module chunks = 0